export default {
  common: {
    esg: {
      category: 'カテゴリ',
      environment: '環境',
      society: '社会',
      governance: 'ガバナンス',
      other: 'その他',
      comprehensive: '総合',
      basic: '基本情報',
    },
    btn: {
      cancel: 'キャンセル',
      add: '追加',
      create: '作成',
      update: '更新',
      apply: '適用',
      close: '閉じる',
      create_new: '新規作成',
      edit: '編集',
      detail: '詳細をみる',
      view_detail: '詳細',
      delete: '削除',
      change: '切替',
      confirm: '確認',
      clear: '条件クリア',
      download: 'ダウンロード',
      save: '保存',
      register: '登録',
      send: '送信',
      check_answer: '回答を確認',
      score_card_list: 'スコアカード一覧',
      confirm_action: '確認する',
      edit_action: '編集する',
      create_action: '作成する',
      add_action: '追加する',
    },
    link: {
      delete: '削除',
      back: '戻る',
    },
    sentence: {
      back_to_login: 'ログインへ戻る',
      back_to_dashboard: 'ダッシュボードへ戻る',
      not_applicable: '対象外※',
      back_to_top: 'トップページに戻る',
      send_the_following: '以下の内容で送信します。',
      add_the_following: '以下の内容で追加します。',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: '調査票/サーベイ',
      questionnaire_short: '調査票',
      target_questionnaire: '調査票/サーベイを選択してください',
      target_year: '対象年度',
      target_year_text: '対象年度を選択してください',
      target_company: '対象会社',
      target_company_text: '対象会社を選択してください',
      total: '全{total}件',
    },
    label: {
      required: '必須',
      optional: '任意',
      year: '年度',
    },
    form: {
      search_word: {
        label: 'フリーワード検索',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'yyyy/MM/dd',
      dateTimeFormatTemp: 'yyyy/MM/dd HH:mm zzz',
      datePickerFormat: 'yyyy/MM/dd',
      datePickerPlaceholder: 'YYYY/MM/DD',
      issue_date: '発行日',
      evaluation_expires_date: '有効期限',
      answer_expires_date: '回答期限',
      last_updated_date: '最終更新日時',
    },
    error: {
      code_0005: '認証に失敗しました。再ログインしてください。',
      code_0007: '必須項目です。',
      code_5001: 'ページが見つかりませんでした。',
      code_0001: '既に最新の設問で提出済みです。',
      code_0002: '他の端末からデータが更新されたため更新できませんでした。再読み込み後、操作を再実行してください。',
      code_0003: 'ファイルを削除できませんでした。少なくとも1つの回答を行ってから削除してください。',
      code_0006: '既に登録済みのユーザーです。',
      code_0004: 'アップロード可能なファイルサイズを超えています。1ファイルのサイズ上限値は50MBです。',
      code_9999: '予期せぬエラーが発生しました。',
    },
    evaluation: {
      title: '評価依頼',
      dashboard: 'ダッシュボード',
      analysis: '分析',
      list: '企業一覧',
    },
    dashboard: {
      title: 'ダッシュボード',
    },
    upload: {
      title: '調査票/サーベイ',
      common: '共通',
    },
    scorecard: {
      title: 'スコアカード',
      list: '一覧',
      detail: '詳細',
      scorecard_detail: 'スコアカード詳細',
      answer_preview: '回答プレビュー',
      breadcrumb_detail: '企業詳細',
    },
    improvementplans: {
      title: '改善計画',
      detail: '@:common.scorecard.detail',
      breadcrumb_detail: '改善計画詳細',
    },
    detailExtra: {
      title: '応用分析',
    },
    settings: {
      title: '設定',
    },
    default_selector: {
      selected_label: 'デフォルト',
      do_select:      'この調査票をデフォルト設定',
      do_release:     'デフォルト設定を解除',
    },
    contact: {
      title: 'よくある質問',
    },
    logout: {
      title: 'ログアウト',
    },
    industry: {
      type_1: '農林水産業',
      type_2: '鉱業・採石業・砂利採取業',
      type_3: '建設業（設備工事業を含む）',
      type_4: '製造業（鉄鋼・非鉄金属・金属製品）',
      type_5: '製造業（機械器具・電子機器等）',
      type_6: '製造業（食品・飲料・たばこ等）',
      type_7: '製造業（パルプ・紙・紙加工品）',
      type_8: '製造業（木材・木製品等加工）',
      type_9: '製造業（化学工業（医薬品を含む）・繊維工業）',
      type_10: '製造業（石油・石炭・ゴム・プラスチック等）',
      type_11: '製造業（印刷業）',
      type_12: '製造業（その他）',
      type_13: '電気・ガス・熱供給・水道業',
      type_14: '情報通信業',
      type_15: '運輸業・倉庫業',
      type_16: '卸売業・小売業',
      type_17: '金融業・保険業',
      type_18: '不動産業',
      type_19: '学校（幼稚園・保育園等を含む）',
      type_20: '宿泊業・飲食サービス業',
      type_21: '生活関連サービス業（洗濯・理容・美容・浴場業等）',
      type_22: '医療・福祉',
      type_23: '廃棄物処理業・リサイクル業',
      type_24: '自動車整備業',
      type_25: '自治体・行政機関等',
      type_26: 'その他',
    },
    scale: {
      a: '1〜29人',
      b: '30〜99人',
      c: '100〜499人',
      d: '500〜999人',
      e: '1000〜4999人',
      f: '5000人〜',
    },
    sales_amount: {
      under_1million: '1億円未満',
      under_10million: '1億〜10億円未満',
      under_100million: '10億〜100億円未満',
      under_1billion: '100億〜1,000億円未満',
      under_10billion: '1,000億〜1兆円未満',
      over_10billion: '1兆円以上〜',
      not_disclose: '回答を希望しない',
    },
    progress: '完了率',
    url: {
      contact: 'https://asuene.com/rating/form/contact',
      asuene: 'https://asuene.com/',
      asuene_lca: 'https://asuene.com/lca',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com',
    },
    head_title: 'ASUENE ESG', // meta title
    company_name_inc: 'アスエネ株式会社',
    breakdown: '内訳',
    help: 'ヘルプ',
    user_display_mode: {
      my_assessment: '自社評価',
      supply_chain_assessment: 'サプライチェーン評価',
    },
    buyer: '評価依頼企業',
    supplier: '被評価企業',
    error_page: {
      section_one: 'ご指定のページは存在しません',
      section_two: 'URLをご確認ください',
      to_dashboard: 'ダッシュボードに戻る',
    },
    priority: {
      good: '良好',
      high: '高',
      medium: '中',
      low: '低',
    },
    priority_full_name: {
      high: 'リスク高',
      medium: 'リスク中',
      low: 'リスク低',
    },
    faq: {
      how_to_use_csv_head: 'ダウンロードしたCSVファイルをExcelで開くには以下の手順に従って進めてください。',
      how_to_use_csv_body_01: '1. 新しい空白のExcelブックを開きます。',
      how_to_use_csv_body_02: '2. [データ] タブで [テキストまたはCSVから] をクリックします。',
      how_to_use_csv_body_03: '3. 対象の .csv ファイルを選択し、[インポート] をクリックします。',
      how_to_use_csv_body_04: '4. 表示されるデータ内容に問題がないことを確認します。',
      how_to_use_csv_body_05: '5. [読み込み] を選択します。',
      how_to_use_csv_note: '※ 手順は使用しているOSやMicrosoft Excelのバージョンによって異なる場合があります。',
    },
    answer_display_status: {
      unanswered: '未回答',
      temporarily_saved: '回答中',
      submitted: '回答済',
      score_rated: '評価済',
      ended: '終了済',
      auto_scored: '仮採点',
    },
    all: 'すべて',
    count: {
      question: '問',
      company: '社',
      unit: '件',
      number_of_questions_label: '設問数',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      sharing: '共有中',
      unshared: '共有終了',
      inviting: '承認待ち',
      viewable: '閲覧可',
      unviewable: '閲覧終了',
    },
    modal: {
      csv_download_mail_sended: {
        title: 'ダウンロード受付完了',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'ステータス',
    notification: {
      send_back: {
        title: '回答が差し戻されました',
        description_1: 'ご回答いただいた{questionGroupName}が差戻しされました。',
        description_2: '内容のご確認をお願いします。',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        title: '回答の取り下げ依頼がありました',
        description_1: '{company}から回答取り下げ依頼がありました。',
        description_2: '内容をご確認いただき、差戻し対応をお願いいたします。',
        comment_label: '取り下げコメント',
      },
      download: {
        csv_success_title: 'CSVファイルの作成が完了しました',
        csv_description_1: 'データをCSVファイルへ集計しました。',
        common_description: '以下のURLをクリックしデータをダウンロードしてください。',
        action: 'ダウンロードする',
        csv_failed_title: 'CSVファイル作成に失敗しました',
        failed_description_1: 'データのダウンロードに失敗しました。',
        failed_description_2: '時間を置いて、再度お試しください。',
        pdf_success_title: 'PDFファイルの作成が完了しました',
        pdf_description_1: 'データをPDFファイルへ集計しました。',
        pdf_failed_title: 'PDFファイル作成に失敗しました',
        attachment_file_success_title: '添付ファイルの準備が完了しました',
        attachment_file_description_1: '添付ファイルをまとめました。',
        attachment_file_failed_title: '添付ファイルの準備に失敗しました',
        file_number: '{number}ファイル目',
      },
      message: {
        title: 'メッセージが届きました',
        description: '改善計画について、{company}からメッセージが届いています。',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        title: '回答マスタが共有されました',
        description: '{name}さんから、以下の回答マスタが共有されました。',
        person_label: '担当者',
        data_label: '@:esg_data.data_name',
        description_1: '回答データを閲覧する場合、以下のURLからメールアドレスの認証を完了し、手続きに進んでください。',
        description_2: 'URLの有効期限は1週間です。1週間以内に手続きを完了してください。',
        modal_description: 'ログアウトしてメールアドレスの認証に進んでよろしいですか？',
      },
      data_share_complete: {
        title: '回答マスタが確認できます',
        description: '{name}さんから、以下の回答データが共有されました。',
      },
      answer_remind: {
        title: '回答期限のお知らせ',
        description: '回答を依頼された{questionGroupName}について、内容をご確認いただき、ご提出いただきますようお願いいたします。',
      },
      empty_description_1: 'まだお知らせは届いていません。',
      empty_description_2: '新しいお知らせが届くと、こちらに表示されます。',
      title: 'お知らせ',
      unread: '未読',
    },
    buyer_create_question: {
      title: 'アンケート作成',
      create_survey: '調査管理',
      answer_list: '回答一覧',
      header_title: '自社作成アンケート',
    },
    information: {
      not_available: 'この機能はまだ使うことができません。',
      please_wait: '機能リリースをお待ちください。',
    },
    action: {
      delete_item: '{item}を削除',
    },
    category_icon: {
      no_select: '選択しない',
      water: '水',
      waste: '廃棄物',
      ghg: 'GHG',
      human_rights: '人権',
      occupational_safety: '労働安全',
      security: 'セキュリティ',
      balance_scale: '天秤',
      icon: 'アイコン',
      check: 'チェック',
    },
    placeholder: {
      input_free: '入力してください',
      half_digits: '半角数字で入力',
    },
    bulk_download_modal: {
      title: 'ファイルダウンロード',
      csv: 'CSV',
      pdf: 'PDF',
      attached_file: '@:improvementplans.attached_file',
      answer_heading: '@:list_table_filter.csv_modal_answer_heading',
      answer_row: '行設定',
      answer_heading_options: {
        company: '@:list_table_filter.csv_modal_answer_heading_supplier',
        question: '@:list_table_filter.csv_modal_answer_heading_question',
      },
      answer_row_options: {
        question: '設問ごと',
        select: '選択肢ごと',
      },
      target_data_options: {
        question_group: '@:list_table_filter.csv_modal_answer_heading_question',
        answer_status_list: '@:list_table_filter.csv_modal_answer_status_title',
        answer_list_by_individual_company: '@:list_table_filter.csv_modal_answer_title_by_individual_company',
        answer_list: '@:list_table_filter.csv_modal_answer_title',
        score: '@:list_table_filter.csv_modal_score_title',
        improvement_plan: '@:common.improvementplans.title',
      },
      description: '「{questionGroupName}」のデータをダウンロードします。\n対象データと出力形式を選択し、[ダウンロード]を押してください。',
      target_data: '対象データ',
      output_type: '出力形式',
      download_completed: 'ファイル出力リクエストを受け付けました。\nメールアドレスへファイルダウンロードURLを送信しますので、しばらくお待ちください。\n30分経ってもメールが来なければ、再度お試しください。'
    },
    company: {
      zip_code: '郵便番号',
      zip_code_placeholder: '1050001',
      prefecture: '都道府県',
      prefecture_placeholder: '東京都',
      address_one: '市区町村',
      address_one_placeholder: '港区',
      address_two: '番地',
      address_two_placeholder: '1-10-5',
      address_three: '建物名など',
      address_three_placeholder: 'KDX虎ノ門',
    }
  },
};
